<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableMessageQueueDate"
      style="width: 100.1%;margin-top:10px"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <Button type="info" size="small" @click="databaseDetail(row)"
          >{{ $t('aiMonitor.detail') }}</Button
        >
        <span @click="doDelete(index)">
          <!-- <Button type="info" size="small" @click="configurationWeight(row)">配置权重</Button> -->
          <Button type="info" size="small" @click="handleShowMonitorIndex(row)"
            >{{ $t('aiMonitor.configMonitorIndex') }}</Button
          >
          <Button
            type="error"
            size="small"
            @click="MessageQueueDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除队列模式框 -->
    <Modal v-model="MessageQueueDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ brokerNames }}
          {{ $t("alarms.common.what") }}？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeMessageQueue()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="ShowMonitorIndexModal"
      :title="$t('aiMonitor.configMonitorIndex')"
      :loading="loading"
      :mask-closable="false"
      width="750"
    >
      <Form ref="MonitorIndexForm" :model="MonitorIndexForm" :label-width="110">
        <FormItem :label="$t('aiMonitor.monitorIndex')" prop="MonitorIndex">
          <Select
            filterable
            v-model="MonitorIndexForm.metricIndex"
            style="width:300px;"
            label-in-value
            @on-change="handleSelectMonitorIndex"
          >
            <Option
              v-for="item in MonitorIndexList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button
            type="primary"
            style="margin-left:20px"
            @click="handleAddMonitorIndex"
            >{{ $t('alarms.common.add') }}</Button
          >
        </FormItem>
        <div
          v-for="(item, index) in MonitorIndexForm.MonitorIndexArr"
          :key="item.id"
        >
          <Row :gutter="4">
            <Col span="10">
              <FormItem :label="$t('aiMonitor.monitorIndex')">
                <Input
                  v-model="item.metricName"
                  style="width:180px"
                  disabled
                ></Input> </FormItem
            ></Col>
            <Col span="10">
              <FormItem :label="$t('aiMonitor.alertThreshold')">
                <Input
                  v-model="item.metricThresholdValue"
                  style="width:180px; "
                ></Input> </FormItem
            ></Col>
            <Col span="4">
              <FormItem label="" :label-width="30">
                <Button type="error" @click="handleDelMonitorIndex(index)"
                  >{{ $t('alarms.common.delete') }}</Button
                >
              </FormItem>
            </Col>
          </Row>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="caseResetMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('alarms.common.cancel') }}</Button
        >
        <Button
          type="primary"
          @click="caseSubmitMonitorIndex('ruleValidateMonitorIndexForm')"
          >{{ $t('common.determine') }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableMessageQueueVue = {};
export default {
  name: "TableMessageQueue",
  data() {
    return {
      ShowMonitorIndexModal: false,
      MonitorIndexForm: {
        metricIndex: "",
        MonitorIndexArr: []
      },
      MonitorIndexList: [
        { id: "1535", name: this.$t('aiMonitor.metrics.messageProducers') },
        { id: "1536", name: this.$t('aiMonitor.metrics.messageConsumers') },
        { id: "1537", name: this.$t('aiMonitor.metrics.totalMessages') },
        { id: "1538", name: this.$t('aiMonitor.metrics.totalQueued') }
      ],
      getItem: {},
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      MessageQueueDelmodal: false,
      isDisable: false,
      modal_loading: false,
      loading: false,
      brokerNames: "",
      val: "",
      region: "",
      columns: [
        {
          title: this.$t("alarms.queue.name"),
          key: "brokerName"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.queue.brokerId"),
          key: "brokerId"
        },
        {
          title: this.$t("alarms.queue.brokerEngine"),
          key: "engineType"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName"
        },
        {
          title: this.$t("alarms.queue.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      tableMessageQueueDate: []
    };
  },
  beforeCreate: function() {
    tableMessageQueueVue = this;
  },
  mounted: function() {
    // tableMessageQueueVue.getMessageQueueData();
  },
  created() {
    eventBus.$on("brokerSummaryIdSearchName", function(val) {
      tableMessageQueueVue.brokerSummaryIdSearchName = val;
    });
    eventBus.$on("companyId", function(region) {
      tableMessageQueueVue.companyId = region;
    });
  },
  methods: {
    caseSubmitMonitorIndex() {
      this.$api.brokerSummary
        .updateQueueWeight({
          applicationId: this.$route.query.id,
          queueId: this.id,
          alertRuleName: this.$route.query.alertRuleName,
          aiMetrics: this.MonitorIndexForm.MonitorIndexArr
        })
        .then(res => {
          this.$Message.success(this.$t('common.operationSuccess'));
          this.ShowMonitorIndexModal = false;
        });
    },
    databaseDetail: function(row) {
      this.$router.push({
        path: "/aiMonitor/queueDetail/",
        query: { queueId: row.id }
      });
    },
    handleShowMonitorIndex(row) {
      this.ShowMonitorIndexModal = true;
      this.id = row.id;
      var lineIndex = this.lineIndex;
      this.$api.brokerSummary
        .selectWeightByApplicationIdAndQueueId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          queueId: row.id
        })
        .then(res => {
          this.MonitorIndexForm.MonitorIndexArr =
            res.data.aiApplicationMetricThresholdDTOS;
          let arr = [];
          this.MonitorIndexForm.MonitorIndexArr.forEach(item => {
            let data = {
              metricThresholdValue: item.thresholdValue,
              metricName: item.metricsName,
              metricIndex: item.metricsId
            };
            arr.push(data);
          });
          this.MonitorIndexForm.MonitorIndexArr = arr;
        })
        .catch(err => {});
    },
    caseResetMonitorIndex(name) {
      this.ShowMonitorIndexModal = false;
      this.MonitorIndexForm.MonitorIndexArr = [];
    },
    handleAddMonitorIndex(name) {
      this.MonitorIndexForm.MonitorIndexArr.push({
        metricIndex: this.getItem.value,
        metricName: this.getItem.label,
        metricThresholdValue: ""
      });
    },
    handleDelMonitorIndex(index) {
      this.MonitorIndexForm.MonitorIndexArr.splice(index, 1);
    },
    handleSelectMonitorIndex(item) {
      console.log(item);
      this.getItem = item;
    },
    showAll: function() {
      tableMessageQueueVue.getMessageQueueData();
    },
    // 分页显示数据
    /****************************************************/
    getMessageQueueData: function() {
      //列表分页
      this.$api.brokerSummary
        .queryQueueByApplicationId({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableMessageQueueDate = res.data.records;

          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableMessageQueueVue.getMessageQueueData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableMessageQueueVue.getMessageQueueData();
    },
    // 销毁brokerSummaryIdSearchName
    beforeDestroy: function() {
      eventBus.$off("brokerSummaryIdSearchName");
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.brokerNames = this.tableMessageQueueDate[index].brokerName;
    },
    removeMessageQueue: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.brokerSummary
        .deleteByApplicationIdAndInstanceId({
          alertRuleName: this.$route.query.alertRuleName,
          applicationId: this.$route.query.id,
          queueId: this.tableMessageQueueDate[lineIndex].id
        })
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableMessageQueueVue.getMessageQueueData();
            this.isDisable = false;
            this.modal_loading = false;
            this.MessageQueueDelmodal = false;
            this.$Message.success(this.$t('common.deleteSuccess'));
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/messageQueueDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          brokerId: row.brokerId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.brokerName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/TableMessageQueue.vue